export const setupWizard = {
  top: {
    title: "Assistente di configurazione",
    subtitleFallback: "Configurazione di base dell'annuncio",
    stepCount: "Passo {current} di {total}",
    closeAria: "Chiudi assistente",
    closeTitle: "Chiudi",
  },
  intro: {
    title: "Configuriamo insieme il tuo alloggio!",
    subBefore: "Ti guideremo passo dopo passo per preparare",
    yourListingFallback: "il tuo annuncio",
    subAfter: "ad accogliere gli ospiti. Non servono competenze tecniche: sistemerai tutto in pochi minuti. 😊",
    start: "Iniziamo!",
    skip: "Non ora, lo farò più tardi",
  },
  steps: {
    confirmation: {
      label: "Conferma della prenotazione",
      desc: "Comunichiamo all'ospite che la sua prenotazione è confermata via WhatsApp ed email. Disattivandolo, non riceverà alcuna notifica. Se prenota tramite una OTA, sarà l'OTA a notificarlo.",
    },
    welcome: {
      label: "Messaggio di benvenuto",
      desc: "Il messaggio che l'ospite riceve subito dopo aver completato il check-in online, con il benvenuto e le istruzioni per l'arrivo.",
    },
    schedule: {
      label: "Programmazione del check-in",
      desc: "Quando vuoi che inviamo all'ospite il link per il check-in?",
    },
    hours: {
      label: "Orari di check-in e check-out",
      desc: "A che ora può arrivare e partire l'ospite?",
    },
    locks: {
      label: "Tipo di serratura",
      desc: "Come entra l'ospite nel tuo alloggio?",
    },
    authorities: {
      label: "Comunicazione alle autorità",
      desc: "Inviamo noi la comunicazione dei viaggiatori alle autorità al posto tuo, senza che tu debba fare nulla.",
    },
    services: {
      label: "Servizi",
      desc: "Configura i servizi e le dotazioni offerti dal tuo alloggio.",
    },
    policies: {
      label: "Politiche",
      desc: "Le regole e le condizioni del tuo alloggio.",
    },
    calendar: {
      label: "Prepara il tuo calendario",
      desc: "Ti mostreremo come preparare il tuo calendario per ricevere prenotazioni.",
    },
  },
  nav: {
    back: "Indietro",
    next: "Avanti",
    finish: "Fine",
  },
  preview: {
    audienceOwner: "Cosa vedi tu (host)",
    audienceGuest: "Cosa vede l'ospite",
    accommodationFallback: "Alloggio",
    online: "online",
    today: "Oggi",
    captionGuestWeb: "Anteprima · web ospite",
  },
  schedule: {
    title: "Quando inizia il check-in?",
    hint: "Programma quando l'agente invia il link per il check-in all'ospite. Si applica a livello di annuncio.",
    caption: "Anteprima · sequenza di check-in",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Vuoi che la conferma della prenotazione venga inviata all'ospite via WhatsApp?",
    toggleHint: "Non appena una prenotazione viene confermata, l'ospite riceverà questo messaggio con tutti i dettagli del soggiorno. Così saprà che è tutto a posto. 😊",
    stateOn: "Sì, invialo",
    stateOff: "Non inviare",
    mapAlt: "Posizione dell'alloggio",
    addressFallback: "Indirizzo dell'alloggio",
    caption: "Anteprima · messaggio di conferma",
    propFallback: "il tuo alloggio",
    guestSample: "Laura García",
    body: "Ciao *{guest}* 👋\n\nLa tua prenotazione presso *{name}* è confermata ✅\n\nCodice prenotazione: *6233Q1VC5*\nDate: *05/06/2026* – *07/06/2026* 📅\n\nTramite questo WhatsApp puoi richiedere il link per il check-in online e ricevere le istruzioni per l'arrivo.\nSe hai bisogno di aiuto prima o durante il soggiorno, scrivici qui 💬",
    cta: "🇬🇧 Per continuare con il check-in, tocca il pulsante *Ok* o scrivi *Ok*.",
  },
  policies: {
    guestBubble: "Per continuare con la procedura devi accettare i nostri termini e condizioni.",
    termsTitle: 'Regolamento · ALLOGGIO TURISTICO "{name}"',
    termsBodyLabel: "I.– REGISTRAZIONE",
    termsBodyText: "Ogni ospite, sia individuale sia parte di un gruppo, deve compilare una scheda di registrazione individualmente o per camera, che verrà fornita all'arrivo o online.",
    accept: "Accetto i termini e le condizioni",
  },
  guestPreview: {
    continue: "Continua",
  },
  authorities: {
    ofTotal: "di {total}",
    heading: "Informazioni richieste dal Regio Decreto 933/2021 del Governo spagnolo",
    intro: "Ai sensi del Regio Decreto 933/2021, in vigore dal 2 dicembre 2024, dobbiamo raccogliere i seguenti dati per rispettare le normative di sicurezza.",
    countryLabel: "Paese di residenza",
    sampleCountry: "🇪🇸 Spain",
    cityLabel: "Città di residenza",
    sampleCity: "Málaga",
    addressLabel: "Indirizzo di residenza",
    sampleAddress: "77 Larios Street",
    postalLabel: "Codice postale di residenza",
  },
  locks: {
    embedEmpty: "Aggiungi prima un'unità all'annuncio per configurare serrature e accessi.",
  },
  calendar: {
    iframeTitle: "Prepara il tuo calendario",
    videoSoon: "Il video sarà disponibile qui molto presto.",
    hint: "Guarda il video e segui i passaggi: in pochissimo tempo il tuo calendario sarà pronto per ricevere prenotazioni. 🎬",
  },
};
